export const UNGROUPED_RESOURCES_GROUP_ID = 'ungrouped-resources';
export const RESTRICTED_GROUP_NAME_VALUE = '__restricted_group_name__';

export const GROUP_TREE_SKELETON_ROW_COUNT = 4;
